<template>
  <div class="mb-md-5">
    <TituloPagina :titulo="tituloDaPagina" />
    <p
      class="pa-0 mt-5 mb-6 primary--text"
      data-cy="texto_da_pagina"
    >
      Dê um apelido para facilitar a identificação do cartão por você
    </p>

    <v-text-field
      v-model.trim="nomeCartao"
      filled
      maxlength="20"
      background-color="white"
      label="Ex: Cartão do banco"
      data-cy="nome_cartao"
      :error-messages="errorNomeCartao"
      @blur="$v.nomeCartao.$touch()"
    />
  </div>
</template>

<script>

import TituloPagina from '@/components/TituloPagina.vue';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'PassoIdentifiqueCartao',

  components: {
    TituloPagina,
  },

  data() {
    return {
      tituloDaPagina: 'Identifique o cartão',
      nomeCartao: '',
      messages: {
        required: 'Por favor, preencha o campo.',
      },
    };
  },

  computed: {
    errorNomeCartao() {
      if (this.$v.nomeCartao.$invalid && this.$v.nomeCartao.$dirty) return this.messages.required;

      return [];
    },
  },

  watch: {
    nomeCartao() {
      this.enviarNomeCartao();
    },
  },

  methods: {
    enviarNomeCartao() {
      const valido = !this.$v.nomeCartao.$invalid;
      const dados = valido ? this.nomeCartao : '';

      this.$emit('formValidado', {
        form: { nickname: dados },
        validado: valido,
      });
    },
  },

  validations: {
    nomeCartao: {
      required,
    },
  },
};
</script>
